import { render, staticRenderFns } from "./UserNotFound.vue?vue&type=template&id=5404e867&"
import script from "./UserNotFound.vue?vue&type=script&lang=ts&"
export * from "./UserNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserNotFound.vue"
export default component.exports